<template>
    <div class="yd-news-lunbo-vertical" @click="newsClick(newsData.newsContentURL)">
        <p class="yd-title">{{newsData.newsContentTitle}}</p>
        <div class="yd-news-content">
            <el-carousel trigger="click" height="150px">
                <el-carousel-item v-for="i in lunboSlideNum" :key="i">
                    <img v-if="lunboImages[i-1]" :src="lunboImages[i-1]" alt="请输入正确的图片地址">
                </el-carousel-item>
            </el-carousel>
            <div v-if="newsData.newsContentSource" class="yd-module-label">
                <span>{{newsData.newsContentSource}}</span>
                <span v-if="newsData.newsContentUpdateTime">{{newsData.newsContentUpdateTime}}</span>
                <span v-else>{{getCurrentTime()}}</span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ["newsData", "lunboSlideNum", "lunboImages"],
    methods: {
        newsClick(url) {
            this.$emit('newsClick', url);
        },
        //获取当前时间，格式为："2017-5-12 17:59:12"
        getCurrentTime() {
            return new Date().toLocaleString();
        }
    }
}
</script>
<style lang="less">
/*轮播图*/
.yd-news-lunbo-vertical {
    margin-top: 10px;
    margin-bottom: 50px;
    height: 480px;
    cursor: pointer;
    .yd-title {
        text-align: left;
        font-size: 14px;
        margin-bottom: 10px;
    }
    .yd-news-content {
        position: relative;
        height: 100%;
        .el-carousel {
            height: 100%;
            img {
                width: 100%;
                height: 100%;
            }
            .el-carousel__container{
                height: 100% !important;
            }
        }
        .yd-module-label {
            text-align: left;
            color: #8492A6;
            font-size: 12px;
            span {
                padding-right: 10px;
            }
        }
    }
}
</style>




// WEBPACK FOOTER //
// SlidesNewsVertical.vue?6f15323c